import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {Field, reduxForm} from 'redux-form';
import FormattedDateTextInput from '../components/FormattedDateTextInput';
import {filterStyles} from '../shared/styles-filter';
import RaisedButton from 'material-ui/RaisedButton';
import {viewStyles} from '../shared/styles-view';
import TextField from 'material-ui/TextField';

/**
 * Set a field for filter entry
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
const renderInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) => {
    return (
        <TextField
            errorText={touched && error}
            {...inputProps}
            {...props}
        />
    )
};

class TransfersByMemoSearchFilter extends Component {

    handleFilterSubmit = () => {
        this.props.onSubmitFilter({date: this.props.filterDateSince, memo: this.props.filterMemo});
    };

    isDisabled = (filterDateSince, filterMemo, loading) => {
        return (!filterDateSince || !filterMemo || filterMemo === '' || filterMemo.length < 3 || loading);
    };

    render() {
        const {
            filterDateSince,
            filterMemo,
            labelDate,
            labelMemo,
            labelSubmit,
            loading
        } = this.props;

        const disabled = this.isDisabled(filterDateSince, filterMemo, loading);

        return (
            <form>
                <div className="list-filter">
                    <span style={viewStyles.filterInline}>
                        <FormattedDateTextInput
                            formName="filterForm"
                            source="filter_date_since"
                            label={labelDate}
                            placeholder="MM/DD/YYYY"
                            maxDate={new Date()}
                            allowInputValue={false}
                            style={viewStyles.filterDateSelect}
                        />
                    </span>
                    <Field
                        id="filter_memo"
                        name="filter_memo"
                        type="text"
                        component={renderInput}
                        floatingLabelText={labelMemo}
                        style={filterStyles.textInputWide}
                    />
                    <RaisedButton
                        primary
                        type="button"
                        label={labelSubmit}
                        disabled={disabled}
                        onClick={this.handleFilterSubmit}
                        style={filterStyles.submitButton}
                    />
                    <hr style={filterStyles.break}/>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['filterForm'];
    if (form && form.values) {
        return {
            filterDateSince: form.values.filter_date_since,
            filterMemo: form.values.filter_memo
        }
    }
    return {
        filterDateSince: null,
        filterMemo: ''
    }
};

TransfersByMemoSearchFilter.propTypes = {
    labelDate: PropTypes.string,
    labelMemo: PropTypes.string,
    labelSubmit: PropTypes.string,
    loading: PropTypes.bool,
    onSubmitFilter: PropTypes.func
};

TransfersByMemoSearchFilter.defaultProps = {
    labelDate: 'Select Since Date',
    labelMemo: 'Enter a Memo value',
    labelSubmit: 'Search',
    loading: false
};

const enhance = compose(
    connect(
        mapStateToProps
    ),
    reduxForm({
        form: 'filterForm'
    })
);

export default enhance(TransfersByMemoSearchFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/TransfersByMemoSearchFilter.js